import _ from "lodash";
import { config } from "../../app/core/config";
import { emptyFn } from "./util";

interface AlertOptions {
    /**
     * Alert message header. This content will be bold.
     */
    header?: string;
    /**
     * Alert message contents. Be sure to mark {@link messageIsHTML} as true if you have any HTML elements.
     */
    message?: string;
    /**
     * Mark true if you inserted any HTML elements into the {@link message}.
     */
    messageIsHTML?: boolean;
    /**
     * Whether the alert should automatically fade after a timeout.
     */
    fade?: boolean;
    /**
     * How long (in ms) to delay before fading or removing the alert.
     */
    wait?: number;
    /**
     * The type of alert. This determines the visual appearance.
     */
    type?: string;
    /**
     * Clickable buttons that will appear on the alert popup.
     */
    buttons?: any[];
    /**
     * Id on the HTML element if you need to use it later
     */
    id?: string;
    /**
     * Action to perform when the alert is closed.
     */
    close?();
}

/*
    * Alert
    * Opens an alert message that looks like GROWL
    *
    *
    * id - ID of the window created
    * close - function you want to execute on close
    * header - bold information at beginning of alert
    * message - message you want to alert
    * type - type of alert message
    *
    * Defaults:
    * id = "alert"
    * type = "warning"
    *
    */
export function alert(options: AlertOptions) {
    if (typeof options == "string") {
        options = {
            message: options
        };
    }

    options = options || {};
    options.wait = options.wait || (config && config.defaultAlertDuration[options.type || "warning"]) || 5000;
    options.fade = options.fade == undefined
        ? true
        : false;
    var templateOptions = {
        data: {
            id: options.id || "",
            type: options.type || "warning",
            header: options.header || "",
            message: options.message || "",
            // This is used to protect against XSS.
            // This needs to be true if the message contents are HTML.
            messageIsHTML: options.messageIsHTML || false
        }
    };
    options.close = options.close || emptyFn;

    var buttonsHTML = "";
    if (options.buttons) {
        options.buttons.forEach(button => {
            button.guid = kendo.guid();
            buttonsHTML += `<a class='link alert-button' guid='${button.guid}'><b>${_.escape(button.title)}</b></a>`;
        });

        buttonsHTML = `<div class="alert-button-container">${buttonsHTML}</div>`;
    }

    const padding = options.buttons
        ? "style='padding-bottom: 25px;'"
        : "";
    var template = kendo.template(
        `<div id='#= data.id #' class='alert alert-#= data.type #' ${padding}>
            <span class='alert-header'>#: data.header #</span>
            <span class='alert-message'>#= data.messageIsHTML ? data.message : _.escape(data.message) #</span>
            <span class='k-icon k-i-close'></span>
            ${buttonsHTML}
        </div>`);

    var alertDomObject = $(template(templateOptions));

    if (options.buttons) {
        options.buttons.forEach(button => {
            button.close = (button.close === undefined)
                ? true
                : button.close;

            alertDomObject.find(`[guid=${button.guid}]`).bind("click", () => {
                if (button.close) {
                    alertDomObject.find(".k-i-close").click();
                }

                button.onClick();
            });
        });
    } else {
        alertDomObject.find(".alert-button").hide();
    }

    if (alertDomObject.find(".alert-header").text() === "") {
        alertDomObject.find(".alert-header").hide();
    }

    if (options.id && $("#AlertContainer").find(`#${options.id}`).length > 0) {
        return null;
    }

    $("#AlertContainer").append(alertDomObject);

    $(alertDomObject).find(".k-i-close").on("click", function () {
        $(this).parents(".alert").remove();
    });

    $(alertDomObject).find(".k-i-close").on("click", options.close);

    if (options.fade) {
        $.wait(options.wait).then(function () {
            $(alertDomObject).fadeTo(1500, 0, function () {
                $(this).remove();
            });
        });
    }
}
